/**
*
* ExpandButton
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ExpandIcon from 'components/media/Icon2/ExpandIcon.jsx';

function ExpandButton(props) {
  const { expanded, disabled, onClick, ...rest } = props;
  return (
    <Button variant="link" disabled={disabled} onClick={onClick} {...rest}>
      <ExpandIcon className="fs-2 text-primary" expanded={expanded} />
    </Button>
  );
}

ExpandButton.propTypes = {
  expanded: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ExpandButton;
